import React, { type FC } from 'react'

import {
    type ClientRegistryRequest,
    selectIsLoading,
    selectIsUsersManagementRegistryLocked,
    selectLoadedRegistryRequests,
    Translation,
} from '../../../../domain'

import { useAsyncCallback } from '../../Callback'
import { DetailsHeader, Table } from '../../common'
import { FormattedDateTime, FormattedTranslation } from '../../Internationalization'
import { useAppState, useAppUsecase } from '../../State'
import { FormattedMethod } from '../Users'
import { LockButton } from './Button'

const NoRequests: FC = () => {
    const locked = useAppState(selectIsUsersManagementRegistryLocked)
    return <FormattedTranslation id={Translation.CLIENT_REGISTRY_NO_REQUESTS} values={{ locked }} />
}

export const RequestsTable: FC = () => {
    const locked = useAppState(selectIsUsersManagementRegistryLocked)
    const requests = useAppState(selectLoadedRegistryRequests)
    const isLoading = useAppState(selectIsLoading)

    const usecase = useAppUsecase('allowClientRegistryRequestUsecase')
    const [onRowClick] = useAsyncCallback((request: ClientRegistryRequest) => usecase.load(request))

    return (
        <>
            <DetailsHeader
                title={Translation.CLIENT_REGISTRY}
                titleActions={<LockButton />}
                description={[Translation.CLIENT_REGISTRY_DOCUMENTATION_TITLE, Translation.CLIENT_REGISTRY_DOCUMENTATION_BODY]}
            />
            <Table
                columns={{
                    username: { label: Translation.USERNAME },
                    description: { label: Translation.CONTEXT },
                    timestamp: {
                        label: Translation.TIMESTAMP,
                        customCellRender: (date) => <FormattedDateTime date={date} format="datetime" />,
                        type: 'datetime',
                    },
                    authenticationMethod: { label: Translation.CREDENTIALS, customCellRender: (method) => <FormattedMethod method={method} /> },
                }}
                pagination={{ pageSize: 15, pageSizeOptions: [15] }}
                data={requests}
                search={!locked}
                onRowClick={isLoading ? undefined : onRowClick}
                translations={{ noResultsOrEmptyTable: <NoRequests /> }}
            />
        </>
    )
}
